<template>
    <div style="height: 100%">
        <CheckInOutList v-show="!rotaAninhada" :reloadData="reloadData" />
        <router-view />
    </div>
</template>

<script>
import CheckInOutList from '@/components/promotor/relatorio-analitico/relatorio-check-in-out/RelatorioCheckInOutList.vue';

export default {
    name: 'RelatorioCheckInOutListRoute',

    beforeRouteUpdate(to, from, next) {
        this.rotaAninhada = to.name != 'relatorio-pro-check-in-out-list';
        if (from.name != 'relatorio-pro-check-in-out-list' && to.name == 'relatorio-pro-check-in-out-list') {
            this.reloadData = true;
            setTimeout(() => (this.reloadData = false), 300);
        }
        next();
    },
    components: {
        CheckInOutList,
    },
    data() {
        return {
            rotaAninhada: false,
            reloadData: false,
        };
    },
    created() {
        this.rotaAninhada =
            this.$route.name.includes('relatorio-pro-check-in-out') &&
            this.$route.name != 'relatorio-pro-check-in-out-list';
    },
};
</script>
